import { render, staticRenderFns } from "./CourseContent.vue?vue&type=template&id=21f189cd&scoped=true&"
import script from "./CourseContent.vue?vue&type=script&lang=js&"
export * from "./CourseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f189cd",
  null
  
)

export default component.exports